import { useCallback, useMemo } from "react";

import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { BrandKey } from "@/types/common-types";
import { RenewalSectionType } from "@/types/renewals";

import Style from "./left-panel.module.css";

export function useLeftPanelUtils(brand: BrandKey) {
  const {
    isLoading,
    expandedSections,
    setExpandedSections,
    setIsSelectItemByLeftPanel,
  } = useRenewalStateContext();

  const handleClick = useCallback(
    (section: RenewalSectionType) =>
      (
        event:
          | React.MouseEvent<HTMLButtonElement>
          | React.KeyboardEvent<HTMLButtonElement>
      ) => {
        event.preventDefault();
        setExpandedSections([section]);
        sessionStorage.setItem("expandedSections", JSON.stringify([section]));
        if (section === "medical-conditions") {
          sessionStorage.setItem("isMedicalAccordionOpen", "true");
        }
      },
    [setExpandedSections]
  );

  const dynamicStyle = (
    uniqueId: RenewalSectionType,
    activeClassName: string,
    defaultClassNme: string
  ) => {
    return `${
      expandedSections.at(-1) === uniqueId ? activeClassName : defaultClassNme
    }`;
  };

  const brandStyleText = useMemo(() => {
    const style = {
      staysure: {
        actColor: "text-text-accent-3-primary",
        defColor: "text-interactive-secondary-default",
        actUnderline: "!decoration-text-accent-3-primary",
        defUnderline: "!decoration-interactive-secondary-default",
      },
      avanti: {
        actColor: "text-interactive-secondary-default",
        defColor: "text-dark-text-accent-5-primary",
        actUnderline: "!decoration-interactive-secondary-default",
        defUnderline: "!decoration-dark-surface-accent-1-secondary",
      },
      expat: undefined,
    };

    return style[brand] ?? style.staysure;
  }, [brand]);

  const brandStyleIcon = useMemo(() => {
    return brand === "avanti" ? Style.avnIcon : Style.stsIcon;
  }, [brand]);

  const states = {
    isLoading,
    expandedSections,
  };

  const styles = {
    dynamicStyle,
    brandStyleText,
    brandStyleIcon,
  };

  const handlers = {
    handleClick,
    setIsSelectItemByLeftPanel,
    setExpandedSections,
  };

  return {
    states,
    styles,
    handlers,
  };
}
